import styled from '@emotion/styled'

import { breakpoints, palette, spacing, Text, typography } from 'main/ui'

export const Container = styled.div`
  align-items: center;
  bottom: 0;
  background: ${palette.white};
  display: flex;
  flex-direction: column;
  padding: 0 0 ${spacing.majorScale(5)}px 0;
  position: fixed;
  width: 100%;
  z-index: 1;

  @media (min-width: ${breakpoints.lg}px) {
    border-top: 1px solid ${palette.chrome};
    flex-direction: row;
    padding: ${spacing.majorScale(1)}px 0;
    position: sticky;
  }

  @media (max-width: ${breakpoints.lg - 1}px) {
    border-radius: 5px;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.7);
  }
`

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${spacing.majorScale(18)}px;
`

export const HeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: auto;
  margin-right: ${spacing.majorScale(1)}px;
`

export const DirectorAvatar = styled.img`
  border-radius: 50%;
  height: 43px;
  width: 43px;
`

export const DirectorName = styled(Text)`
  font-weight: ${typography.fontWeight.bold};
  margin-bottom: -${spacing.minorScale(1)}px;
`

export const SchoolName = styled(Text)`
  font-size: ${typography.fontSize.hint};
  margin-left: ${spacing.majorScale(3)}px;
`

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints.lg}px) {
    margin-left: ${spacing.majorScale(2)}px;
  }

  @media (max-width: ${breakpoints.lg - 1}px) {
    flex-direction: row;
    width: 100%;
    padding: ${spacing.majorScale(2)}px;
  }
`
